import React from 'react';

const CircularProgressBar = ({
  progress,
  size = 100,
  strokeWidth = 10,
  circleColor = '#e5e7eb', // Tailwind gray-200
  progressColor = 'currentColor', // Default to text color
  textColor = 'currentColor', // Default to text color
  fontSize = 'text-xl', // Tailwind font size classes
  fontWeight = 'font-semibold', // Tailwind font weight classes
  duration = 300, // Animation duration in milliseconds
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <svg
      width={size}
      height={size}
      className="transform"
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
        stroke={circleColor}
        fill="transparent"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
        stroke={progressColor}
        fill="transparent"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        className={`transition-all duration-${duration} ease-linear`}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy=".3em"
        className={`${fontSize} ${fontWeight}`}
        fill={textColor}
      >
        {progress}%
      </text>
    </svg>
  );
};

export default CircularProgressBar;
